// extracted by mini-css-extract-plugin
module.exports = {"container":"ExcoPlayer_container__qr9qa"};